import { render, staticRenderFns } from "./ContentfulSelect.vue?vue&type=template&id=48b56460"
import script from "./ContentfulSelect.vue?vue&type=script&lang=ts"
export * from "./ContentfulSelect.vue?vue&type=script&lang=ts"
import style0 from "./ContentfulSelect.vue?vue&type=style&index=0&id=48b56460&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports